module.exports = __webpack_public_path__ + "assets/img/block-left-hover-ebb7a95c.png";